Selector.View.JurisdictionSelectView = Backbone.View.extend({
    // Change the tagName to 'div' so that the view generates a <div>
    tagName: 'div',

    events: {
        'change select': 'onJurisdictionChange'  // Listen to the change event on the <select> element inside the div
    },

    initialize: function(options) {
        this.jurisdictions = options.jurisdictions || [];
        this.resultModel = options.resultModel; // Pass the result model in options
        this.divId = options.divId || 'jurisdiction-inner-container'; // Allow passing a custom ID for the div

        // Bind the render method to always have the correct context
        _.bindAll(this, "render");

        // Listen for changes to the 'results' attribute in the resultModel
        this.listenTo(this.resultModel, 'change:results', this.render);

        // Optionally, you can also call the first render here, or control it from the parent view
        this.render();
    },

    render: function() {
        // Empty the div before re-rendering
        this.$el.empty();
        
        // Set the ID on the div element
        this.$el.attr('id', this.divId);

        this.$el.prepend('<label for="state" class="selector_label">Select your state to get your custom list of prescribed documents: </label>');
        // Create the <select> element
        const select = $('<select id="state" class="form-select"></select>');

        // Get current results from the model
        let currentResults = this.resultModel.get('results');

        // Only render jurisdictions if there are results
        let hasOptions = false;
        if (Array.isArray(currentResults) && currentResults.length > 0) {
            this.jurisdictions.forEach(jurisdiction => {
                if (jurisdiction.JURISDICTIONDELETED === 0) {
                    const option = $('<option></option>')
                        .val(jurisdiction.JURISDICTIONID)
                        .text(jurisdiction.JURISDICTIONNAME);

                    // Preselect the jurisdiction if needed
                    if (jurisdiction.JURISDICTIONID == this.resultModel.get('jurisdictionId')) {
                        option.attr('selected', 'selected');
                    }

                    // Append the option to the select element
                    select.append(option);
                    hasOptions = true;  // At least one option exists
                }
            });
            if(this.resultModel.get('jurisdictionId') === 0){
                select.prepend('<option value="0" selected>---Please select---</option>')
            }
        }

        // Append the <select> element inside the <div>
        this.$el.append(select);

        // Check if the select element is empty and add a specific class to the div if needed
        if (!hasOptions) {
            this.$el.addClass('empty-select');
        } else {
            this.$el.removeClass('empty-select');
        }

        return this;
    },

    onJurisdictionChange: function(event) {
        // Get the selected jurisdiction ID from the <select> element
        const selectedJurisdiction = this.$('select').val();

        // Update the result model with the new jurisdiction
        this.resultModel.set('jurisdictionId', parseInt(selectedJurisdiction));

        // Trigger the 'fetchProduct' event to update the results view
        this.resultModel.fetchProduct();
    }
});
